export default {"src":"/_next/static/media/groceries.f8c12883.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};